import React from 'react';
import { getOptions } from '../aggregationUtil';
import { newInteractiveFilter } from './interactiveFilter';

const Filter = newInteractiveFilter('city_id', getOptions);

export const CityInteractiveFilter = ({
  cities,
  aggregationQuery,
  onSelectValue,
  onClearValue,
  label,
  ...additionalProps
}) => (
  <Filter
    options={cities}
    aggregationQuery={aggregationQuery}
    onSelectValue={onSelectValue}
    onClearValue={onClearValue}
    label={label}
    {...additionalProps}
  />
);
